import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import Pagination from "../../model/pagination";
import ProfileMediumModel from "../../model/insights/profileMedium.model";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import QueryEncoder from "../queryEncoder";

@Injectable()
export default class MediumService {
    public constructor(private http: HttpClient) {
    }

    public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additionalInfo?: any): Observable<Pagination<ProfileMediumModel>> {
        query = query || '';
        page = page || 1;
        limit = limit || 15;
        sort = sort || '';

        let sorting = {};
        sorting[sort] = direction;

        let q = {query, page, limit, sorting};


        if (additionalInfo) {
            Object.assign(q, additionalInfo);
        }
        return this.http.get<Pagination<ProfileMediumModel>>(environment.apiUrl + '/profile-media?' + QueryEncoder.encodeURI(q));
    }

    public show(id: number): Observable<ProfileMediumModel> {
        return this.http.get<ProfileMediumModel>(environment.apiUrl + '/profile-media/' + id);
    }
}
